// components/partnerOnboarding/dashboardTour.js
import React from 'react';

function DashboardTour() {
  return (
    <div>
      <h3 className="mb-4">Dashboard Tour</h3>
      <p>Great job setting up your account! Let's take a quick tour of your new dashboard.</p>
      <div className="mb-3">
        <h5>Analytics Overview</h5>
        <p>Track your referrals and view the progress of your earnings over time</p>
      </div>
      <div className="mb-3">
        <h5>Claim Commissions</h5>
        <p>Claim your commissions in stablecoins as they are generated.</p>
      </div>
      <div className="alert alert-success" role="alert">
        You're all set! If you have any questions, our support team is here to help.
      </div>
    </div>
  );
}

export default DashboardTour;